import {
  Draggable,
  Flip,
  gsap,
  MotionPathPlugin,
  ScrollTrigger,
} from "gsap/all";
import projectHero from "./projectHero";

export default () => {
  gsap.registerPlugin(ScrollTrigger, MotionPathPlugin, Draggable, Flip);

  projectHero();
};
